import { development } from 'app/config/constants'
import { CopyButton } from 'component/Button/CopyButton'
import { Gap, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { getLang } from 'i18n/config/LanguageDetector'
import { observer } from 'mobx-react-lite'
import { SizeTile } from 'page/BasicInferenceScreen/SizeTile'
import { getColorTranslation } from 'page/StartScreen/combine/utils'
import { ReactElement } from 'react'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { getItemShapeLabel, ItemData } from 'type/Inference'
import { disk } from 'util/typo'
import css from './ItemPane.module.scss'

type Props = {
  item: ItemData
  shape?: boolean
  full?: boolean
}

type Desc = {
  title?: string
  text?: string
}

function parseDesc(desc?: string): Desc | undefined {
  desc = desc?.trim()
  if (development) return {
    title: 'трц «саларис» • павильон 334',
    text: 'описание '.repeat(33),
  }
  if (!desc) return undefined

  let eol = desc.indexOf('\n')
  if (eol < 0) eol = desc.length
  const title = desc.substring(0, eol).trim()
  const text = desc.substring(eol).trim()
  return { title, text }
}

export const ItemPane = observer((props: Props): ReactElement | undefined => {
  const { item, full } = props
  const shape = props.shape ? getItemShapeLabel(item) : undefined
  const { article, brand, color, product, description } = item
  const combine = !!opt.options.combine
  const lang = getLang()
  const { hide_name_for_en } = opt.options
  const hide_name = lang === 'en' && hide_name_for_en && combine
  const desc = parseDesc(description)
  const size = 16
  const ellipsis = !full

  const onClick = useLatestCallback(() => {
    store.carousel.extend = store.carousel.extend ? undefined : item
  })

  if (!brand && !product) return undefined

  return <Space gap={16} pad={16}>
    <Vertical wide oh onClick={onClick}>
      <Vertical gap={4}>
        <Space gap={8}>
          {shape && <Typo className={css.shape} one size={12} upper>
            {shape}
          </Typo>}
          {shape && brand && <Typo one size={16} tertiary>
            {disk}
          </Typo>}
          <Typo one size={16} upper secondary ellipsis={ellipsis}>
            {brand}
          </Typo>
        </Space>
        {product && !hide_name && <Typo size={24} semi upper ellipsis={ellipsis}>
          {product}
        </Typo>}
      </Vertical>
      <Gap height={2} />
      <Vertical gap={2}>
        {article && <Space gap={8}>
          <Typo size={size} tertiary upper>
            {i18n('Articul')}
          </Typo>
          <Typo size={size} upper ellipsis={ellipsis}>
            {article}
          </Typo>
          <CopyButton size={24} data={article} />
        </Space>}
        {color && <Space gap={8}>
          <Typo size={size} tertiary upper>
            {i18n('Color')}
          </Typo>
          <Typo size={size} upper>
            {getColorTranslation(color)}
          </Typo>
        </Space>}
      </Vertical>
      {desc && <Gap height={2} />}
      {desc && <Vertical>
        {desc.title && <Typo size={size} upper ellipsis={ellipsis}>
          {desc.title}
        </Typo>}
        {desc.text && <Typo size={16} tertiary ellipsis={ellipsis}>
          {desc.text}
        </Typo>}
      </Vertical>}
    </Vertical>
    {!full && <SizeTile />}
  </Space>
})
